/* eslint-disable camelcase */
import Vue from 'vue';
export default function appendComponentToBody(params) {
    const node = document.createElement('div');
    document.body.appendChild(node);
    const vm = new Vue({
        el: node,
        render(h) {
            return h(params.component, {
                ref: 'appendComponentToBody',
                props: params.componentProps
            });
        }
    });
    return vm.$children[0];
}
